module.exports = __webpack_public_path__ + "static/media/data_security_icon.5386808c.svg";